<div class="content-button">
  @if (!hasMealPlan && !hasTickets) {
  <div class="text">
    En este momento
    <strong>no hay tickets disponibles </strong>
    <span>para esta habitacíon</span>
  </div>
  } @else {
    @if (!optionalSupplements) {
    <div class="alert">
      <mb-icon icon="exclamation-circle"></mb-icon>
      <p>Para seleccionar esta opción deberás elegir en el proximo paso las entradas</p>
    </div>
    } @else {
    <span class="optional"><p>Opcional:</p></span>
    }

    @if (hasMealPlan) {
      @if (!optionalSupplements) {
      <span class="optional"><p>Incluido en la tarifa:</p></span>
      }
      <div class="added">
        <div class="cards">
          <mb-icon icon="restaurant"></mb-icon>
          <span><p>plan de comída</p></span>
        </div>
      </div>
      @if (isFreeMealPlan) {
      <div class="added">
        <div class="cards">
          <mb-icon icon="upgrade-disney"></mb-icon>
          <span><p>Entradas a los parques</p></span>
        </div>
      </div>
      }
    }
    @if (hasTickets && !isFreeMealPlan) {
      @if (!optionalSupplements) {
      <span class="optional"><p>No incluído en la tarifa</p></span>
      }
      <div class="added">
        <div class="cards">
          <mb-icon icon="upgrade-disney"></mb-icon>
          <span><p>Entradas a los parques</p></span>
        </div>
      </div>
    }
  }
</div>
